declare global {
  interface Window {
    Shopify?: {
      routes: any;
      locale?: string;
      country?: string;
    };
  }
}

/**
 * 不区分渠道：window.Shopify.locale 与 country 均存在时返回语言-地区标识。
 * 格式示例 en-FR；任一缺失返回 undefined，不上报脏数据。
 */
export function getShopifyCustomerLocale(): string | undefined {
  const locale = window?.Shopify?.locale;
  const country = window?.Shopify?.country;
  if (!locale || !country) {
    return undefined;
  }
  return `${locale}-${country}`;
}
